import { Clock4 } from 'lucide-react'
import { useSessionTimer, formatRemaining } from './useSessionTimer'

/**
 * AF-402 — topbar countdown.
 *
 * Renders nothing while the session is fresh; shows a compact
 * countdown chip once we're within the configured countdown window
 * (default 5 min) and switches to a destructive tone inside the
 * warning window (default 2 min). The modal handles the actual
 * "extend session" action; this is purely the at-a-glance signal so
 * the operator knows time is ticking even when the modal isn't yet
 * open.
 */
export function SessionCountdownBadge() {
  const { phase, remainingMs } = useSessionTimer()
  if (phase === 'fresh' || phase === 'expired') return null

  const isWarning = phase === 'warning'
  return (
    <span
      className={
        'flex items-center gap-1 rounded border px-2 py-0.5 font-mono text-[0.6875rem] tabular-nums ' +
        (isWarning
          ? 'border-destructive/40 bg-destructive/10 text-destructive'
          : 'border-amber-300/60 bg-amber-100/60 text-amber-700 dark:border-amber-500/30 dark:bg-amber-900/30 dark:text-amber-300')
      }
      title={
        isWarning
          ? 'Your session is about to expire. Click to stay signed in.'
          : 'Session activity countdown'
      }
      aria-live="polite"
      aria-label={`Session ${formatRemaining(remainingMs)} remaining`}
    >
      <Clock4 className="h-3 w-3" />
      <span>{formatRemaining(remainingMs)}</span>
    </span>
  )
}
